import { useTranslation } from 'react-i18next';
import { Button } from '@src/components';
import SidebarLayout from '@src/components/SidebarLayout';
import StepsList, { StepListStep } from '@src/components/StepsList';

export interface OrderLayoutProps {
  steps: StepListStep[];
  onExitClick: () => void;
  headerName?: string;
  title: string;
}

function OrderLayout({
  steps,
  onExitClick,
  headerName,
  title,
}: OrderLayoutProps): JSX.Element {
  const { t } = useTranslation();
  const getSidebarContent = ({
    closeSidebar,
  }: {
    closeSidebar: () => void;
  }): JSX.Element => (
    <div>
      <h2>{title}</h2>
      <StepsList onClick={closeSidebar} steps={steps} />
    </div>
  );
  return (
    <SidebarLayout
      sidebarContent={getSidebarContent}
      headerContent={
        <div className="flex flex-1 items-center justify-between">
          <div className="md:invisible">{headerName}</div>
          <div>
            <Button color="gray" size="round" onClick={() => onExitClick()}>
              {t('buttons.exit', 'Exit')}
            </Button>
          </div>
        </div>
      }
    />
  );
}

export default OrderLayout;
